const buildTourFilterOptions = (counts, selected) => {
  const entries = Object.entries(counts || {}).sort(([, left], [, right]) => right - left);
  const missing = (selected || [])
    .filter((value) => !entries.some(([name]) => name === value))
    .map((value) => [value, 0]);

  const options = [...entries, ...missing].map(([name, count]) => ({
    value: name,
    label: `${name} (${count})`,
    plainTextLabel: name,
  }));

  return options;
};

export default buildTourFilterOptions;
